import { getComponentClasses } from '@99designs/frontend-components/utils/app/index';
import React from 'react';
import VelocityScrollable from '../../lib/VelocityScrollable';

interface Props {
    children: React.ReactNode;
    style?: object;
    variations?: string[];
}

export default class Scrollable extends React.Component<Props> {
    private containerRef: React.RefObject<HTMLDivElement>;
    private innerRef: React.RefObject<HTMLDivElement>;

    constructor(props: Props) {
        super(props);

        this.containerRef = React.createRef<HTMLDivElement>();
        this.innerRef = React.createRef<HTMLDivElement>();
    }

    componentDidMount() {
        this.initVelocity();
    }

    private initVelocity() {
        if (this.innerRef.current) {
            // tslint:disable-next-line:no-unused-expression
            new VelocityScrollable(
                this.innerRef.current,
                document.documentElement!,
                window.requestAnimationFrame.bind(window) as Function
            );
        }
    }

    center() {
        const scrollableContainer = this.innerRef.current;

        if (!scrollableContainer) {
            return;
        }

        const middleChildPosition = Math.round(scrollableContainer.children.length / 2) - 1;
        const childWidth = scrollableContainer.children[0].clientWidth;

        const childOffset = (scrollableContainer.children[middleChildPosition] as HTMLElement)
            .offsetLeft;
        const viewportOffsetWidth = (window.innerWidth - childWidth) / 2;

        scrollableContainer.scrollLeft = childOffset - viewportOffsetWidth;
    }

    offCenter(offset: number) {
        const scrollableContainer = this.innerRef.current;

        if (!scrollableContainer) {
            return;
        }

        const middleChildPosition = Math.round(scrollableContainer.children.length / 2) - 1;
        const childWidth = scrollableContainer.children[0].clientWidth;

        const childOffset = (scrollableContainer.children[middleChildPosition] as HTMLElement)
            .offsetLeft;
        const viewportOffsetWidth = (window.innerWidth - childWidth) / 2;

        scrollableContainer.scrollLeft = childOffset - viewportOffsetWidth - offset;
    }

    setScrollLeft(offset: number) {
        if (this.innerRef.current) {
            this.innerRef.current.scrollLeft = offset;
        }
    }

    render() {
        const { style, variations } = this.props;
        const classes = getComponentClasses('scrollable', variations ? variations : []);

        return (
            <div className={classes} ref={this.containerRef} style={style}>
                <div className="scrollable__inner" ref={this.innerRef}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}
